import { Button, Grid, GridColumn, Heading, Modal, ModalContent, Notice, Text } from '@teliaee/design-system';
import DOMPurify from 'dompurify';
import { observer } from 'mobx-react';
import React from 'react';
import { MERGE_ENDPOINT } from '../stores/MergeStore';
import useStores from '../stores/UseStores';

const EmailMergeConfirmModal = observer((): React.JSX.Element | null => {
  const {
    mergeStore,
    accountInfoStore,
    addEmailStore,
    translateStore: { translate },
  } = useStores();
  const { submitting, calledMergeEndpoint, mergeConfirmationModalOpen, setMergeConfirmationModalState, handleLogin } = mergeStore;

  const getMergeConfirmation = () => {
    if (mergeStore.canMergeAccounts()) {
      return (
        <Grid align={['center-xs']} className="text-center">
          <GridColumn width={['xs-12', 'md-8', 'lg-12']}>
            <Text>
              <Notice direction="vertical">
                <Heading level={1} className="h3 text-center" id="join-accounts-modal-title">
                  {translate('MergeConfirm.title')}
                </Heading>
              </Notice>
              <p>
                {translate('MergeConfirm.p', {
                  account1: accountInfoStore.accountName,
                  account2: addEmailStore.email || DOMPurify.sanitize(mergeStore.resolvedMergeParams.mergeAccount || ''),
                })}
              </p>
              <p>
                <Button
                  isLoading={submitting && calledMergeEndpoint === MERGE_ENDPOINT.MERGE}
                  disabled={submitting && calledMergeEndpoint !== MERGE_ENDPOINT.MERGE}
                  text={translate('merge_accounts.merge_button_label')}
                  onClick={() => handleLogin(MERGE_ENDPOINT.MERGE, false, true)}
                />
              </p>
              <p>
                <Button
                  variant={'secondary'}
                  isLoading={submitting && calledMergeEndpoint === MERGE_ENDPOINT.CANCEL}
                  disabled={submitting && calledMergeEndpoint !== MERGE_ENDPOINT.CANCEL}
                  text={translate('merge_accounts.cancel_merge_button_label')}
                  onClick={() => handleLogin(MERGE_ENDPOINT.CANCEL, false, true)}
                />
              </p>
            </Text>
          </GridColumn>
        </Grid>
      );
    }
  };

  return (
    <Modal isOpen={mergeConfirmationModalOpen} size="6-col" aria-labelledby="email-exists-modal-title" onClose={() => setMergeConfirmationModalState(false)}>
      <ModalContent>{getMergeConfirmation()}</ModalContent>
    </Modal>
  );
});

export default EmailMergeConfirmModal;
